import { render, staticRenderFns } from "./experimentListDetail.vue?vue&type=template&id=2c6c7ca0&scoped=true&"
import script from "./experimentListDetail.vue?vue&type=script&lang=js&"
export * from "./experimentListDetail.vue?vue&type=script&lang=js&"
import style0 from "./experimentListDetail.vue?vue&type=style&index=0&id=2c6c7ca0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6c7ca0",
  null
  
)

export default component.exports